import AxiosService from './AxiosService';

class AIChatService {
  constructor() {
    if (!AIChatService.instance) {
      AIChatService.instance = this;
    }
    return AIChatService.instance;
  }

  serviceEndpoint = 'octoagent';

  listSessions = async (params, options) => {
    const response = await AxiosService.get(`${this.serviceEndpoint}/chats`, {
      params,
      ...options,
    });
    return response.data;
  };

  createSession = async (payload, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chats`,
      payload,
      options
    );
    return response.data;
  };

  getSession = async (sessionId, options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chats/${sessionId}`,
      options
    );
    return response.data;
  };

  getMessages = async (sessionId, options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chats/${sessionId}/messages`,
      {
        params: { streaming: 'false', include_pending: 'false' },
        ...options,
      }
    );
    const data = response.data;
    return Array.isArray(data) ? data : data?.messages ?? [];
  };

  getSendMessageStreamingEndpoint = (sessionId) => {
    return `${import.meta.env.VITE_API_BASE_PATH}/${this.serviceEndpoint}/chats/${sessionId}/messages`;
  };

  getMessagesStreamingEndpoint = (sessionId, params) => {
    const qs = new URLSearchParams({
      streaming: 'true',
      ...params,
    });
    return `${import.meta.env.VITE_API_BASE_PATH}/${this.serviceEndpoint}/chats/${sessionId}/messages?${qs.toString()}`;
  };
}

const instance = new AIChatService();
Object.freeze(instance);

export default instance;
